import { notification } from '@edulastic/common'
import axios from 'axios'

import { sanitizeHtml } from '@edulastic/common/src/utils/html'
import API from './utils/API'

const sanitizeScratchPad = (data) => {
  const zwibblerStart = 'zwibbler3.'
  if (data.startsWith?.(zwibblerStart)) {
    try {
      const substr = data.substring(zwibblerStart.length, data.length)
      const dataArr = JSON.parse(substr)
      for (let i = 0; i < dataArr.length; ++i) {
        if ('htmlStr' in dataArr[i])
          dataArr[i].htmlStr = sanitizeHtml(dataArr[i].htmlStr)
      }
      return zwibblerStart + JSON.stringify(dataArr)
    } catch (e) {
      return sanitizeHtml(data)
    }
  }
  // should never happen but if it happens zwibbler would not show it so sanitizing just incase.
  return sanitizeHtml(data)
}

const api = new API()
const prefix = '/attachments'

const isValidURL = (str) => {
  const regex = /(http|https):\/\/(\w+:{0,1}\w*)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%!\-\\/]))?/
  return regex.test(str)
}

const loadDataFromUrl = (dataUrl) =>
  axios({
    url: dataUrl,
    method: 'get',
  }).catch(() => {
    notification({ type: 'error', messageKey: 'unableToRetrieve' })
  })

const loadAttachment = (attachmentId) =>
  api
    .callApi({
      url: `${prefix}/${attachmentId}`,
      method: 'get',
    })
    .then(async (result) => {
      const attachment = result.data.result
      if (
        attachment?.data?.scratchpad &&
        isValidURL(attachment?.data?.scratchpad)
      ) {
        try {
          const { data } = await loadDataFromUrl(attachment?.data?.scratchpad)
          attachment.data.scratchpad = sanitizeScratchPad(data)
        } catch (error) {
          attachment.data.scratchpad = ''
        }
      }
      return attachment
    })

const saveAttachment = (data) =>
  api
    .callApi({
      url: `${prefix}/`,
      method: 'post',
      data,
    })
    .then((result) => result.data.result)

const loadAllAttachments = (filter) =>
  api
    .callApi({
      url: `${prefix}/`,
      method: 'get',
      params: filter,
    })
    .then(async (result) => {
      const { attachments, users } = result?.data?.result || {}
      for (const attachment of attachments) {
        if (
          attachment?.data?.scratchpad &&
          isValidURL(attachment?.data?.scratchpad)
        ) {
          try {
            const { data } = await loadDataFromUrl(attachment?.data?.scratchpad)
            attachment.data.scratchpad = sanitizeScratchPad(data)
          } catch (error) {
            attachment.data.scratchpad = ''
          }
        }
      }
      return { attachments, users }
    })

const updateAttachment = (data) =>
  api.callApi({
    url: `${prefix}/`,
    method: 'put',
    data,
  })

const downloadAllAttachments = (utaId) =>
  api.callApi({
    url: `${prefix}/zip/${utaId}`,
    method: 'get',
  })

export default {
  loadAttachment,
  saveAttachment,
  loadAllAttachments,
  updateAttachment,
  downloadAllAttachments,
  loadDataFromUrl,
}
